import { Popover, PopoverProps } from "@mui/material";

export type SHPopoverProps = PopoverProps;
export const SHPopover = (props: SHPopoverProps): JSX.Element => (
  <Popover {...props} />
);
